export const INIT_USER = "INIT_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const DATA = "DATA";
export const TICKET_COUNT = "TICKET_COUNT";
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const WALLETS = "WALLETS";
export const WALLETDETAILS = "WALLETDETAILS";
export const ADDCART = "ADDCART";
export const TICKET_SEEN = "TICKET_SEEN";
export const TICKET_BADGE_NUMBER = "TICKET_BADGE_NUMBER";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const UPDATE_UNSEEN_ANNOUNCEMENTS = "UPDATE_UNSEEN_ANNOUNCEMENTS";
export const UPDATE_SEEN_ANNOUNCEMENTS = "UPDATE_SEEN_ANNOUNCEMENTS";
export const GET_SEEN_ANNOUNCEMENTS = "GET_SEEN_ANNOUNCEMENTS";

export const initUser = (user) => {
  return {
    type: INIT_USER,
    user,
  };
};

export const updateUser = (user) => {
  return {
    type: INIT_USER,
    user,
  };
};

export const logoutUser = () => {
  return {
    type: LOGOUT_USER,
  };
};

export const setData = (data) => ({
  type: DATA,
  data,
});

export const setCountTicket = (count = 0) => ({
  type: TICKET_COUNT,
  count,
});

export const showModal = (modal, props = undefined) => ({
  type: SHOW_MODAL,
  modal,
  props,
});

export const hideModal = () => ({
  type: HIDE_MODAL,
});

export const walletsData = (payload) => {
  return {
    type: WALLETS,
    payload,
  };
};
export const walletDetails = (details) => {
  return {
    type: WALLETDETAILS,
    details,
  };
};

export const addCart = (item) => {
  return {
    type: ADDCART,
    item,
  };
};

export const updateUserData = (payload) => {
  return {
    type: UPDATE_USER_DATA,
    payload,
  };
};

export const ticketSeen = (bool) => {
  return {
    type: TICKET_SEEN,
    bool,
  };
};

export const updateTicketBadgeNumber = (payload) => {
  return {
    type: TICKET_BADGE_NUMBER,
    payload,
  };
};

export const updateUnseenAnnouncements = (payload) => {
  return {
    type: UPDATE_UNSEEN_ANNOUNCEMENTS,
    payload,
  };
};

export const getSeenAnnouncements = (payload) => {
  return {
    type: GET_SEEN_ANNOUNCEMENTS,
    payload,
  };
};

export const updateSeenAnnouncements = (payload) => {
  return {
    type: UPDATE_SEEN_ANNOUNCEMENTS,
    payload,
  };
};
